"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jul 20 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link PriceList price list}.
 *
 * @author RV
 */


var PriceListConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceListConverter, _DataObjectConverter_);

  function PriceListConverter() {
    _classCallCheck(this, PriceListConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListConverter).apply(this, arguments));
  }

  return PriceListConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceListConverter = PriceListConverter;